import { render, staticRenderFns } from "./title.vue?vue&type=template&id=4e0aa56a&scoped=true&"
var script = {}
import style0 from "./title.vue?vue&type=style&index=0&id=4e0aa56a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0aa56a",
  null
  
)

export default component.exports